import { FileExplorer } from '@features/files';

export function FilesPage() {
  return <FileExplorer />;
}
